import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=d89ecf4a&"
import script from "./Config.vue?vue&type=script&lang=ts&"
export * from "./Config.vue?vue&type=script&lang=ts&"
import style0 from "./Config.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Config.vue"
export default component.exports